import { render, staticRenderFns } from "./Calls.vue?vue&type=template&id=107d4db5&"
import script from "./Calls.vue?vue&type=script&lang=ts&"
export * from "./Calls.vue?vue&type=script&lang=ts&"
import style0 from "./Calls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports